import Model from '../services/model/model';
import Adapter from '../services/model/adapters/json-api/adapter';

Model.setAdapter(Adapter);